import { apiCall } from './api';
import { PDF_CONTENT, PDF_CONTENT_SITE, PDF_CONTENT_DETAILS, PDF_CONTENT_STATUS, PDF_CONTENT_STATS } from '../config/api';

// Get all PDF Content
export const getPdfContents = async (params = {}) => {
  try {
    console.log('🚀 getPdfContents called with params:', params);
    
    // Use site-specific endpoint if site_id is provided
    let endpoint = PDF_CONTENT;
    if (params.site_id) {
      endpoint = PDF_CONTENT_SITE.replace('{site_id}', params.site_id);
      console.log('🔗 Making API call to site-specific endpoint:', endpoint);
    } else {
      console.log('🔗 Making API call to general endpoint:', endpoint);
    }
    
    const response = await apiCall(endpoint, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getPdfContents:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getPdfContents:', error);
    throw error;
  }
};

// Get PDF Content by ID
export const getPdfContentById = async (pdfContentId) => {
  try {
    const endpoint = PDF_CONTENT_DETAILS.replace('{id}', pdfContentId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching PDF Content:', error);
    throw error;
  }
};

// Create new PDF Content
export const createPdfContent = async (pdfContentData) => {
  try {
    console.log('🚀 createPdfContent called with data:', pdfContentData);
    console.log('🔗 Making API call to:', PDF_CONTENT);
    
    const response = await apiCall(PDF_CONTENT, {
      method: 'POST',
      data: pdfContentData
    });
    
    console.log('📡 API Response from createPdfContent:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating PDF Content:', error);
    throw error;
  }
};

// Update PDF Content
export const updatePdfContent = async (pdfContentId, pdfContentData) => {
  try {
    const endpoint = PDF_CONTENT_DETAILS.replace('{id}', pdfContentId);
    const fullUrl = `${endpoint}`; // Will be combined with API_BASE_URL in apiCall
    console.log('🚀 updatePdfContent called with ID:', pdfContentId);
    console.log('📦 Data being sent:', JSON.stringify(pdfContentData, null, 2));
    console.log('🔗 Endpoint path:', endpoint);
    console.log('🔗 Full URL will be: /api' + endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: pdfContentData
    });
    
    console.log('📡 API Response from updatePdfContent:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating PDF Content:', error);
    throw error;
  }
};

// Delete PDF Content
export const deletePdfContent = async (pdfContentId) => {
  try {
    const endpoint = PDF_CONTENT_DETAILS.replace('{id}', pdfContentId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting PDF Content:', error);
    throw error;
  }
};

// Update PDF Content status
export const updatePdfContentStatus = async (pdfContentId, status) => {
  try {
    const endpoint = PDF_CONTENT_STATUS.replace('{id}', pdfContentId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating PDF Content status:', error);
    throw error;
  }
};

// Get PDF Content statistics
export const getPdfContentStats = async () => {
  try {
    const response = await apiCall(PDF_CONTENT_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching PDF Content stats:', error);
    throw error;
  }
};
